<mat-form-field [matTooltip]="disabledMessage()" [matTooltipDisabled]="!disabled()" class="w-full" cdkOverlayOrigin #trigger="cdkOverlayOrigin" [subscriptSizing]="subscriptSizing()">
	<mat-label>{{label()}}</mat-label>
	<input matInput [disabled]="disabled()" #inputField="ngModel" [required]="required()" readonly [ngModel]="value?.displayName" (click)="isOpen = true" class="cursor-pointer" (ngModelChange)="onChange($event)" (blur)="onTouched()">

	<mat-icon matSuffix (click)="isOpen = true" class="cursor-pointer" [ngClass]="{ 'pointer-events-none text-slate-300': disabled()}">arrow_drop_down</mat-icon>
	<mat-error>{{label()}} is required</mat-error>
</mat-form-field>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOffsetY]="-22" [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" (detach)="isOpen = false" [cdkConnectedOverlayWidth]="trigger.elementRef.nativeElement.offsetWidth">
	<div class="max-h-80 w-full overflow-y-auto rounded-md border border-gray-300 bg-white shadow-md" (clickOutside)="isOpen = false">
		@for (option of options(); track option) {
			<div (click)="selectOption(option)" class="cursor-pointer p-4 hover:bg-gray-100">
				<div class="font-semibold text-gray-800">{{ option.displayName }}</div>
				<div class="text-sm text-gray-600">{{ option.description }}</div>
			</div>
		}
	</div>
</ng-template>
